<template>
  <div >
    <div class="form-group my-4">
      <label :for="'img_' + inputId" >{{label}}</label>
      <div >
       <center>
        <div  >
          <img width="50%" :src="value" class="location-photo" :name="'img_' + inputId"  :id="'img_' + inputId" @error="imgLoadError">
          <i  v-if="!hasPhoto()" :name="'no_img_' + inputId"  :id="'no_img_' + inputId" class="fa fa-picture-o fa-5x align-content-center"></i>
        </div>
        <br/>
        <span :id="'error_' + inputId" v-show="!errors.has(inputId)" class="help is-invalid" style="display: none; color: red">Invalid Image</span>
        <span :id="'required_' + inputId" v-show="errors.has(inputId)" class="help is-invalid" style="display: none; color: red" >{{ errors.first(inputId) }}</span>
    
        </center>
      </div>
      <div >
        <input type="file" :name="'file_' + inputId"  :id="'file_' + inputId" class="upload-file" @change="didSelectFile">
      </div>  
    </div>
    <div class="form-group">
      <label :for="inputId">{{label}} URL:</label>
      <input type="text" v-validate="validationRule" :name="inputId"  :id="inputId" class="form-control" :value="value" @input="urlUpdated($event.target.value)">
    </div>
  </div>
</template>
<script>

import {storage} from '../../../firebase'
import $ from 'jQuery'
import Vue from 'vue'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate, { fastExit: false })

export default{
  inject: ['$validator'],
  props: {
    inputId: {
      type: String,
      default: 'localImage'
    },
    value: {type: String},
    label: '',
    validationRule: {type: String, default: ''}
  },
  data: function () {
    return {}
  },
  updated: function () {
    $('#error_' + this.inputId).hide()
  },
  methods: {
    didSelectFile: function (e) {
      // console.log('did select file', this.$props)
      this.didSelectImage(e)
    },
    hasPhoto: function () {
      return this.value && this.value.length > 0
    },
    didSelectImage: function (e) {
      const files = e.target.files || e.dataTransfer.files
      var self = this
      if (files.length > 0) {
        const file = files[0]
        let storageRef = storage.ref().child('images').child('locations').child(file.name)
        storageRef.put(file)
          .then(snap => {
            const downloadURL = snap.downloadURL
            // console.log('download URL: ', downloadURL)
            self.$emit('input', downloadURL)
            self.urlUpdated(downloadURL)
          })
      }
    },
    urlUpdated: function (newval) {
      $('#error_' + this.inputId).hide()
      $('#img_' + this.inputId).show()

      if (newval.trim().length > 0) {
        $('#no_img_' + this.inputId).hide()
        $('#img_' + this.inputId).attr('src', newval).on('load', function (e) {
          console.log('loaded')
          $('#error_' + this.inputId).hide()
          $('#img_' + this.inputId).show()
          $('#no_img_' + this.inputId).hide()
        })
      } else {
        $('#img_' + this.inputId).hide()
        $('#no_img_' + this.inputId).show()
        $('#img_' + this.inputId).attr('src', '')
      }
      this.$emit('input', newval)
    },
    imgLoadError: function (e) {
      console.log('loading error for ' + this.inputId)
      if (this.hasPhoto()) {
        $('#error_' + this.inputId).show()
        $('#img_' + this.inputId).hide()
        $('#no_img_' + this.inputId).show()
      }
      // console.log(e)
    }
  }
}
</script>

<style type="text/css">

#locationPhoto{
  height: auto;
  width: 200px;
  background-color: #eee;
}

/* logo and photo */
input.upload-file{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// remote-image.vue?44b8235c